import styled from 'styled-components';
import { Modal } from 'antd';

export const PantheonModalRegistration = styled(Modal)`
  .ant-modal-content {
    width: ${props => (props.isDemoFormVisible ? '130%' : '100%')};
    left: ${props => (props.isDemoFormVisible ? '-15%' : '0')};

    @media (max-width: 476px) {
      width: 80%;
      margin: 0px auto;
      left: 0px;
    }
  }
  .ant-modal-body {
    padding: ${props => (props.isDemoFormVisible ? '0px' : '30px 40px 40px')};
    @media (max-width: 476px) {
      padding: ${props => (props.isDemoFormVisible ? '0px' : '20px')};
      .signup-form--submit-button,
      .signup-form--submit-button-final {
        width: 100%;
      }
      .ant-form-item {
        margin-bottom: 13px;
      }
    }
    .signup-form--footer-1 {
      display: none;
    }
  }
`;

export const CustomerFilter = styled.div`
  border: #c4c4c4 1px solid;
  margin-top: 20px;
  display: table;
  width: 100%;
  padding: 0px 30px 0px 30px;
  cursor: pointer;

  .pantheon-registration--selection {
    display: table-cell;
    vertical-align: middle;
    height: 80px;

    @media (max-width: 476px) {
      height: 60px;
      font-size: 14px;
    }
  }
`;

export const FormTitle = styled.div`
  display: flex;
  .pantheon-registration--form-title {
    margin-left: 21.5px;
  }
`;
